import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TaskLogSection  {
    _originalTypeClassName = "zERP.BO.TaskLogSection";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TaskLogSection.translate = translateService;
}
this.Messages = [];
this.SubSections = [];
this.Id = null;
this.Title = null;
this.Date = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Title:any;
Date:any;
Messages:any;
SubSections:any;
static setMessages = ($this, items) => {
                if (items == null) items = [];
                if ($this.Messages == null) $this.Messages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Messages.length > 0) {
                    Domain.TaskLogSection.removeMessages($this, $this.Messages[0]);
                }

                Domain.TaskLogSection.addManyMessages($this, copyItems);
            }
static addManyMessages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TaskLogSection.addMessages($this, items[i]);
                }
            }
static addMessages = ($this, item) => {
                if ($this.Messages == null) $this.Messages = [];
                if (item == null || $this.Messages.indexOf(item) > -1) return;
                $this.Messages.push(item);
}
static addRangeMessages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TaskLogSection.addMessages($this, item));
            }
static removeMessages = ($this, item) => {
                if ($this == null || $this.Messages == null || $this.Messages.indexOf(item) === -1) return;
                var _index = $this.Messages.indexOf(item);
                $this.Messages.splice(_index, 1);
}
static clearMessages = ($this) => { $this.Messages = null; }
static setSubSections = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubSections == null) $this.SubSections = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubSections.length > 0) {
                    Domain.TaskLogSection.removeSubSections($this, $this.SubSections[0]);
                }

                Domain.TaskLogSection.addManySubSections($this, copyItems);
            }
static addManySubSections = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TaskLogSection.addSubSections($this, items[i]);
                }
            }
static addSubSections = ($this, item) => {
                if ($this.SubSections == null) $this.SubSections = [];
                if (item == null || $this.SubSections.indexOf(item) > -1) return;
                $this.SubSections.push(item);
}
static addRangeSubSections = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TaskLogSection.addSubSections($this, item));
            }
static removeSubSections = ($this, item) => {
                if ($this == null || $this.SubSections == null || $this.SubSections.indexOf(item) === -1) return;
                var _index = $this.SubSections.indexOf(item);
                $this.SubSections.splice(_index, 1);
}
static clearSubSections = ($this) => { $this.SubSections = null; }

static AddMessage($this: any, severity: any,text: any): any{let msg = new Domain.TaskLogEntry();
msg.Text = text;
msg.LogLevel = severity;
$this?.Messages?.add(msg);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}